import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import DebugService from './DebugService';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const DEFAULT_LOCALE = 'en';
const DEFAULT_TRANSLATIONS = {
  en: {
    translation: {
      "label.title": "Chatbot in english 🙂",
      "label.input.placeholder": "",  // pas de message par defaut
      "label.input.send": "OK",
      "label.welcomeMessage": "Hi ! What can I do for you ?",
      "label.rating.message": "Please qualify this conversation",
      "label.validating.error.maxlength": "Please enter less than 15 characters.",
      "label.errorMessage": "An error occured, please try later."
    }
  },
  fr: {
    translation: {
      "label.title": "Chatbot en français 🙂",
      "label.input.placeholder": "",
      "label.input.send": "OK",
      "label.welcomeMessage": "Salut ! Que puis-je faire pour vous ?",
      "label.rating.message": "Vous pouvez noter cette conversation",
      "label.validating.error.maxlength": "Please enter less than 15 characters.",
      "label.errorMessage": "An error occured, please try later."
    }
  }
};

/**
 * Service
 * @folder Services
 * @class
 */
class I18nService {

  /**
   * Renvoie l'instance du service
   * @returns {Service} singleton instance
   */
  static getInstance() {
    if (!I18nService._instance) {
      I18nService._instance = new I18nService();
      if (DebugService.getInstance().enabled) console.log('I18nService - instanciated.');
    }
    return I18nService._instance;
  }

  constructor() {
    this.DEBUG = DebugService.getInstance().enabled;
    this.initialized = false;   // flag true/false
    this.locale = undefined;  // 2 digit locale, get by enpoint hello
  }

  init(locale = DEFAULT_LOCALE,resources = DEFAULT_TRANSLATIONS) {
    if (this.DEBUG) console.log('I18nService - init...',{locale,resources});
    this.locale = locale;
    i18n
      .use(initReactI18next) // passes i18n down to react-i18next
      .init({
        resources,
        lng: locale, // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
        // if you're using a language detector, do not define the lng option

        interpolation: {
          escapeValue: false // react already safes from xss
        }
      });
    this.initialized = true;
  }

  /**
   * Get static translation
   * @param {string} key
   * @returns {string}
   */
  t(key) {
    return i18n.t(key);
  }

  /**
   * Get translation and replace occurence of %s by the macro (if found)
   * @param {string} key
   * @param {any} m1
   * @returns {string}
   */
  tr(key,m1) {
    let r = i18n.t(key);
    if (r.indexOf('%s') !== -1) {
      r = r.replace('%s',m1);
    }
    return r;
  }

  exists(key) {
    return i18n.exists(key);
  }
}

I18nService._instance = null;

export default I18nService;
